import { PasswordRule, PatternRule } from './password-rule';

//
// Represents a password policy as per the User Service.
export class PasswordPolicy {
  // The rules which make up the policy
  public rules: Array<PasswordRule>;

  // In our case, the program for which the policy is effective.
  public scope: string;

  constructor() {
    this.rules = [];
  }

  //
  // This is meant to be used when processing data from the service as just providing the type as
  // as generic to the http.get call does not seem to actually apply this class as the prototype.
  hydrateFrom(source: PasswordPolicy) {
    this.scope = source.scope;

    this.rules = [];
    source.rules.forEach(sourceRule => {
      //Here we determine the specific type of rule being checked.  In the event of new types
      //being added beyond "PatternRule" we will need to adjust this method to create an
      //appropriate local instance

      const newRule = new PatternRule();
      newRule.hydrateFrom(sourceRule as PatternRule);
      this.rules.push(newRule);
    });
  }
}
